export { fetchPatientLetters, fetchPatientNotes } from "./patient-content-service";